import React from 'react';
import PropTypes from "prop-types";
import iex from 'assets/images/iex.png';
import i41 from 'assets/images/i41.svg';

const propTypes = {
  increment: PropTypes.func.isRequired,
  decrement: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

class CartItem extends React.PureComponent {
  constructor() {
    super();
    this.handleIncrement = this.handleIncrement.bind(this);
    this.handleDecrement = this.handleDecrement.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.focus = this.focus.bind(this);
    this.input = null;
  }

  handleIncrement() {
    const { increment, item } = this.props;
    increment(item);
  }

  handleDecrement() {
    const { decrement, item } = this.props;
    decrement(item);
  }

  handleChange(e) {
    const { change, item } = this.props;
    change(item, e.target.value);
  }

  handleRemove() {
    const { remove, item } = this.props;
    remove(item);
  }

  focus() {
    if(this.input) {
      this.input.select();
    }
  }

  render() {
    const { item } = this.props;

    return (
      <div className="nt--user-card-products-list-item">
        <span className="nt-prod-image">
          <img src={item.image || iex} alt="" />
        </span>
        <div>
          <div className="nt--ucp-product-name">
            <strong>{item.name}</strong>
            <span>{item.name_second}</span>
          </div>
          <div className="nt--ucp-product-quantity">
            <span className="quantity-changer-container">
              <button className="change-icon minus icon-minus" type="button" onClick={this.handleDecrement} />
              <input
                ref={node => this.input = node}
                value={item.$quantity}
                name="quantity"
                onClick={this.focus}
                onChange={this.handleChange}
              />
              <button className="change-icon plus icon-plus" type="button" onClick={this.handleIncrement}/>
            </span>
          </div>
        </div>
        <button className="delete-btn" type="button" onClick={this.handleRemove}>
          <img src={i41} alt="" />
        </button>
      </div>
    );
  }
}

CartItem.propTypes = propTypes;
export default CartItem;


// WEBPACK FOOTER //
// ./src/partialComponents/panelWrapper/subcomponents/cart/CartItem.jsx